import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

const AuthTestPage = () => {
  const { user, isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>🔍 Test d'Authentification</h1>
      
      <div style={{ backgroundColor: '#f5f5f5', padding: '20px', margin: '20px 0', borderRadius: '8px' }}>
        <h2>État d'authentification :</h2>
        <p><strong>Connecté :</strong> {isAuthenticated ? '✅ Oui' : '❌ Non'}</p>
        <p><strong>Admin :</strong> {isAdmin ? '✅ Oui' : '❌ Non'}</p>
        <p><strong>En chargement :</strong> {isLoading ? '⏳ Oui' : '✅ Non'}</p>
      </div>

      <div style={{ backgroundColor: '#e8f5e8', padding: '20px', margin: '20px 0', borderRadius: '8px' }}>
        <h2>Données utilisateur :</h2>
        <pre style={{ backgroundColor: '#f0f0f0', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>

      <div style={{ backgroundColor: '#e8f0ff', padding: '20px', margin: '20px 0', borderRadius: '8px' }}>
        <h2>Actions :</h2>
        <Link to="/login" style={{ margin: '10px', padding: '10px 20px', backgroundColor: '#007bff', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
          Se connecter
        </Link>
        <Link to="/dashboard" style={{ margin: '10px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
          Accéder au Dashboard
        </Link>
        <Link to="/admin/events" style={{ margin: '10px', padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
          🎯 Admin Events
        </Link>
        <Link to="/" style={{ margin: '10px', padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', textDecoration: 'none', borderRadius: '4px', display: 'inline-block' }}>
          Retour à l'accueil
        </Link>
      </div>

      <div style={{ backgroundColor: '#fff3cd', padding: '20px', margin: '20px 0', borderRadius: '8px' }}>
        <h2>🛠️ Test de connexion :</h2>
        <p>1. Allez sur <Link to="/login?auto=admin">Login Auto Admin</Link></p>
        <p>2. Ou connectez-vous manuellement avec : <code>admin@fsf.com</code> / <code>password123</code></p>
        <p>3. Vérifiez que les informations ci-dessus se mettent à jour</p>
      </div>
    </div>
  );
};

// export default AuthTestPage;
export default AuthTestPage